export const AudioBriefingError = {
	CONTENT_TOO_SHORT: 'content-too-short',
	GENERAL_ERROR: 'general-error',
} as const;

export type AudioBriefingErrorType = (typeof AudioBriefingError)[keyof typeof AudioBriefingError];
